import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { AutomotiveAftermarketFiltersDictionaryFacade } from './automotive-aftermarket-filters-dictionary.facade';

@Injectable({
  providedIn: 'root',
})
export class AutomotiveAftermarketFiltersDictionaryGuard {
  constructor(private automotiveAftermarketFiltersDictionaryFacade: AutomotiveAftermarketFiltersDictionaryFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.automotiveAftermarketFiltersDictionaryFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.automotiveAftermarketFiltersDictionaryFacade);
  }
}
